import { useCurrentUser } from 'hooks/auth';

export const useIsBroadbeanEnabled = (): boolean => {
  const { data } = useCurrentUser();

  return data?.currentCompanyUser?.company?.is_broadbean_enabled ?? false;
};
